module.exports = __webpack_public_path__ + "fonts/NuberNext-DemiBold.woff2";